import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { ISubtopicMobile } from "../../../Pages/SubtopicMobile/ISubtopicMobile";

export const EditSubtopicMobileSlice = createSlice({
  name: "EditSubtopicMobileSlice",
  initialState: {} as IReduxState<ISubtopicMobile>,
  reducers: {
    EditSubtopicMobile: (state, _: PayloadAction<ISubtopicMobile>) => {
      state.isLoading = true;
    },
    successEditSubtopicMobile: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureEditSubtopicMobile: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearEditSubtopicMobileResponse: (state) => {
      state.data = {};
    },
  },
});

export const {
  EditSubtopicMobile,
  failureEditSubtopicMobile,
  successEditSubtopicMobile,
  clearEditSubtopicMobileResponse,
} = EditSubtopicMobileSlice.actions;

export default EditSubtopicMobileSlice.reducer;
